import React, { useEffect, useMemo, useState, useContext } from 'react';
import styled, { ThemeContext } from 'styled-components';
import * as THREE from 'three';
import SVG from '../common/svg';
import { useSelector } from 'react-redux';
import { getOwnerMeshType } from '../../lib/threejs/meshTransforms';

const SliderContainer = styled.div`
  position: absolute;
  inset: 0;
  z-index: 13;
  pointer-events: none;
  user-select: none;

  .slider {
    position: absolute;
    top: 16px;
    left: 16px;
    width: 164px;
    height: 336px;
  }

  .hide {
    display: none;
  }

  /* .slider-container {
        position: absolute;
        right: 0;
        top: 15px;
        left: 20px;
        height: 0px;
        width: 0px;
        background-color: red;
    } */
  .upper1,
  .upper2,
  .upper3,
  .lower1,
  .lower2,
  .lower3 {
    position: absolute;
    left: 0;
    width: 164px;
    height: 56px;
    pointer-events: auto;
  }
  .upper-left {
    position: absolute;
    top: 0px;
    width: 56px;
    height: 56px;
    background-color: transparent;
    cursor: pointer;
  }
  .upper-right1,
  .upper-right2,
  .upper-right3 {
    position: absolute;
    top: 10px;
    left: 60px;
    width: 104px;
    height: 56px;
    opacity: 1;
    padding-top: 2px;
  }

  .lower-left {
    position: absolute;
    /* top: -2px; */
    width: 56px;
    height: 56px;
    background-color: transparent;
    cursor: pointer;
  }
  .lower-right1,
  .lower-right2,
  .lower-right3 {
    position: absolute;
    top: 10px;
    left: 60px;
    width: 104px;
    height: 56px;
    opacity: 1;
    padding-top: 2px;
  }

  .btn-toggle {
    outline: 0;
    position: absolute;
    /* top: 127px; */
    background-color: transparent;
    border: none;
    width: 56px;
    height: 56px;
    padding: 0;
    cursor: pointer;
    focus: disabled;
    margin: 70px 0 0 0;
    pointer-events: auto;
  }

  /* Range Slider */
  input[type='range'] {
    box-sizing: border-box;
    /* font-size: 18px; */
    /* line-height: 1; */
    height: 26px;
    background-color: transparent;
    cursor: pointer;
    -webkit-appearance: none;
    width: 100%;
  }
  input[type='range']:focus {
    outline: none;
  }
  input[type='range']::-webkit-slider-thumb {
    -webkit-appearance: none;
    width: 18px;
    height: 18px;
    margin-top: -10px;
    background-color: rgba(113, 120, 128, 1);
    border-radius: 50%;
    /* border: 2px solid rgba(48, 57, 69, 0.15); */
    border: 1px solid rgba(113, 120, 128, 1);
    /* cursor: pointer; */
  }
  input[type='range']::-webkit-slider-runnable-track {
    width: 100%;
    /* cursor: pointer; */
    height: 2px;
    border-top: 2px solid rgba(48, 57, 69, 0.15);
    border-bottom: 2px solid rgba(48, 57, 69, 0.15);
    border-radius: 0.25em;
    background-color: transparent;
  }
  input[type='range']::-moz-range-thumb {
    -moz-appearance: none;
    width: 18px;
    height: 18px;
    margin-top: -10px;
    background-color: #717880;
    border-radius: 50%;
    /* border: 2px solid rgba(48, 57, 69, 0.15); */
    border: 0px solid #717880;
    cursor: pointer;
  }
  input[type='range']::-moz-range-track {
    width: 100%;
    cursor: pointer;
    height: 2px;
    border-top: 1px solid rgba(48, 57, 69, 0);
    border-bottom: 1px solid rgba(48, 57, 69, 0);
    border-radius: 0.25em;
    background-color: rgba(48, 57, 69, 0.15);
  }

  /* Common
  font-size: ${(props) => props.fontSize || '16px'}; */
`;

export const getVisibleJawControls = (loadingOrder = []) => {
  const availableControls = new Set();

  loadingOrder.forEach((name) => {
    const normalizedName = name.toLowerCase();
    const isUpper =
      normalizedName.includes('maxillary') || normalizedName.includes('upperjaw');
    const isLower =
      normalizedName.includes('mandibular') || normalizedName.includes('lowerjaw');
    if (!isUpper && !isLower) return;

    const jaw = isUpper ? 'upper' : 'lower';
    const variant = normalizedName.includes('preop')
      ? '1'
      : normalizedName.includes('scanbody') || normalizedName.includes('marker')
      ? '3'
      : '2';
    availableControls.add(`${jaw}${variant}`);
  });

  return ['upper1', 'upper2', 'upper3', 'lower1', 'lower2', 'lower3'].filter(
    (control) => availableControls.has(control),
  );
};

function SliderBox({
  arrObj,
  marginObj,
  loading_order,
  loading_order_margin,
  transControl,
  fileType,
  scene,
  ambi_light,
  light,
  geoLen,
  colors,
  temp_colors,
  pivot,
  trackball,
  findingGroup,
  focusVisibleJawOnReset = false,
}) {
  const themeContext = useContext(ThemeContext);
  const [isJawClicked1, setIsJawClicked1] = useState(true);
  const [isJawClicked2, setIsJawClicked2] = useState(true);
  const [isJawClicked3, setIsJawClicked3] = useState(true);
  const [isJawClicked4, setIsJawClicked4] = useState(true);
  const [isJawClicked5, setIsJawClicked5] = useState(true);
  const [isJawClicked6, setIsJawClicked6] = useState(true);
  const [isSolidClicked, setIsSolidClicked] = useState(false);
  const [isSpecularLightEnabled, setIsSpecularLightEnabled] = useState(true);
  const [isResetClicked, setIsResetClicked] = useState(false);
  const [isMeasureClicked, setIsMeasureClicked] = useState(false);
  const isSolidVisible = fileType !== 'stl';
  const [sliderValue1, setSliderValue1] = useState(100);
  const [sliderValue2, setSliderValue2] = useState(100);
  const [sliderValue3, setSliderValue3] = useState(100);
  const [sliderValue4, setSliderValue4] = useState(100);
  const [sliderValue5, setSliderValue5] = useState(100);
  const [sliderValue6, setSliderValue6] = useState(100);

  const visibleJawControls = useMemo(
    () => getVisibleJawControls(loading_order),
    [loading_order],
  );
  const isSpecularToggleVisible = arrObj.some(
    (mesh) => mesh.material?.uniforms?.uSpecularEnabled,
  );

  const getJawControlStyle = (control) => {
    const index = visibleJawControls.indexOf(control);
    return {
      display: index < 0 ? 'none' : 'block',
      top: `${Math.max(index, 0) * 56}px`,
    };
  };

  const setFindingJawVisible = (ownerMeshType, visible) => {
    if (!findingGroup) return;
    findingGroup.children.forEach((marker) => {
      if (marker.userData.ownerMeshType === ownerMeshType) marker.visible = visible;
    });
  };

  const movePivotWithoutMovingChildren = (worldCenter) => {
    if (!pivot) return;

    pivot.updateWorldMatrix(true, true);
    const childWorldMatrices = pivot.children.map((child) => ({
      child,
      matrixWorld: child.matrixWorld.clone(),
    }));
    const localCenter = pivot.parent
      ? pivot.parent.worldToLocal(worldCenter.clone())
      : worldCenter;

    pivot.position.copy(localCenter);
    pivot.updateMatrix();
    pivot.updateWorldMatrix(true, false);

    const pivotWorldInverse = pivot.matrixWorld.clone().invert();
    childWorldMatrices.forEach(({ child, matrixWorld }) => {
      const localMatrix = new THREE.Matrix4().multiplyMatrices(
        pivotWorldInverse,
        matrixWorld,
      );
      localMatrix.decompose(child.position, child.quaternion, child.scale);
      child.updateMatrix();
    });
    pivot.updateWorldMatrix(true, true);
  };

  const recenterVisibleJaws = () => {
    if (!focusVisibleJawOnReset || !trackball) return;

    const visibleJaws = { upper: [], lower: [] };
    arrObj.forEach((mesh, index) => {
      const filename = (mesh.userData.fileName || loading_order[index] || '')
        .toLowerCase();
      const jaw =
        filename.includes('maxillary') || filename.includes('upperjaw')
          ? 'upper'
          : filename.includes('mandibular') || filename.includes('lowerjaw')
            ? 'lower'
            : null;
      const materials = Array.isArray(mesh.material)
        ? mesh.material
        : [mesh.material];
      const hasVisibleMaterial = materials.some(
        (material) => material && material.opacity > 0,
      );

      if (jaw && mesh.visible && hasVisibleMaterial) visibleJaws[jaw].push(mesh);
    });

    const meshesToFrame =
      visibleJaws.upper.length > 0 && visibleJaws.lower.length === 0
        ? visibleJaws.upper
        : visibleJaws.lower.length > 0 && visibleJaws.upper.length === 0
          ? visibleJaws.lower
          : [...visibleJaws.upper, ...visibleJaws.lower];
    if (meshesToFrame.length === 0) return;

    pivot.updateMatrixWorld(true);
    const bounds = meshesToFrame.reduce(
      (combinedBounds, mesh) =>
        combinedBounds.union(new THREE.Box3().setFromObject(mesh)),
      new THREE.Box3().makeEmpty(),
    );
    const center = bounds.getCenter(new THREE.Vector3());
    const size = bounds.getSize(new THREE.Vector3());
    const camera = trackball.object;
    const padding = 1.25;

    movePivotWithoutMovingChildren(center);

    camera.up.set(0, 1, 0);
    if (camera.isPerspectiveCamera) {
      const verticalFov = THREE.MathUtils.degToRad(camera.fov);
      const distanceForHeight =
        (size.y * padding) / (2 * Math.tan(verticalFov / 2));
      const distanceForWidth =
        (size.x * padding) /
        (2 * Math.tan(verticalFov / 2) * camera.aspect);
      camera.position.set(
        center.x,
        center.y,
        center.z + Math.max(70, distanceForHeight, distanceForWidth),
      );
    } else if (camera.isOrthographicCamera) {
      const visibleWidth = camera.right - camera.left;
      const visibleHeight = camera.top - camera.bottom;
      camera.zoom = Math.min(
        3,
        visibleWidth / (size.x * padding),
        visibleHeight / (size.y * padding),
      );
      camera.position.set(center.x, center.y, center.z + 400);
    }

    camera.lookAt(center);
    camera.updateProjectionMatrix();
    trackball.target.copy(center);
    trackball.update();
  };

  const resetAllMeshes = () => {
    if (!pivot) return;

    // Détacher le TransformControl
    transControl.detach();

    // arrObj.forEach((mesh) => {
    //   mesh.position.set(0, 0, 0);
    //   mesh.rotation.set(Math.PI / 2, Math.PI, 0);
    //   mesh.scale.set(1, 1, 1);
    //   mesh.updateMatrix();
    // });

    // Reset du pivot
    pivot.rotation.set(0, 0, 0);
    pivot.updateMatrix();

    trackball.reset();
    recenterVisibleJaws();

    // Réattacher le TransformControl
    transControl.attach(pivot);
    transControl.enabled = true;
  };

  const handleMeasureClick = () => {
    const newMeasureMode = !isMeasureClicked;
    setIsMeasureClicked(newMeasureMode);
    transControl.setMeasureMode(newMeasureMode);
  };

  useEffect(() => {
    setIsSolidClicked(false);
  }, [fileType]);

  const UpperJaw1 = (sumMESH) => {
    setIsJawClicked1(!isJawClicked1);
    for (var i = 0; i < loading_order.length; i++) {
      if (
        loading_order[i].search('maxillary-preop') > 0 ||
        loading_order[i].search('upperjaw-preop') > 0
      ) {
        sumMESH[i].visible = !sumMESH[i].visible;
        if (!sumMESH[i].visible) {
          document.getElementsByClassName('slider1')[0].disabled = true;
          document.getElementsByClassName('slider1')[0].style.cursor = 'default';
          document.getElementsByClassName('upper-right3')[0].style.opacity = '0.45';
          setSliderValue1(0);
          setTransparent(arrObj[i], 0);
        } else {
          document.getElementsByClassName('slider1')[0].disabled = false;
          document.getElementsByClassName('slider1')[0].style.cursor = 'pointer';
          document.getElementsByClassName('upper-right3')[0].style.opacity = '1';
          setSliderValue1(100);
          setTransparent(arrObj[i], 100);
        }
      }
    }
  };
  const UpperJaw2 = (sumMESH) => {
    setIsJawClicked2(!isJawClicked2);

    // show/hide margin line
    for (var index = 0; index < loading_order_margin.length; index++) {
      var fileName = loading_order_margin[index];
      var filenameRegex = new RegExp('(.?[^?])-margin', 'gm');
      var matches = filenameRegex.exec(fileName); //ex) result: 17-margin
      if (matches != null && matches[0]) {
        var margin_number = matches[0].split(/-/); //result: [17, margin]
      }
      if (
        (Number(margin_number[0]) >= 11 && Number(margin_number[0]) <= 18) ||
        (Number(margin_number[0]) >= 21 && Number(margin_number[0]) <= 28)
      ) {
        marginObj[index].visible = !marginObj[index].visible;
      }
    }

    for (var i = 0; i < loading_order.length; i++) {
      //mainscan
      if (
        loading_order[i].search('marker') < 0 &&
        loading_order[i].search('scanbody') < 0 &&
        loading_order[i].search('preop') < 0
      ) {
        if (
          loading_order[i].search('maxillary') > 0 ||
          loading_order[i].search('upperjaw') > 0
        ) {
          sumMESH[i].visible = !sumMESH[i].visible;
          setFindingJawVisible(1, sumMESH[i].visible);
          if (!sumMESH[i].visible) {
            document.getElementsByClassName('slider2')[0].disabled = true;
            document.getElementsByClassName('slider2')[0].style.cursor = 'default';
            document.getElementsByClassName('upper-right1')[0].style.opacity = '0.45';
            setSliderValue2(0);
            setTransparent(arrObj[i], 0);
          } else {
            document.getElementsByClassName('slider2')[0].disabled = false;
            document.getElementsByClassName('slider2')[0].style.cursor = 'pointer';
            document.getElementsByClassName('upper-right1')[0].style.opacity = '1';
            setSliderValue2(100);
            setTransparent(arrObj[i], 100);
          }
        }
      }
    }
  };
  const UpperJaw3 = (sumMESH) => {
    setIsJawClicked3(!isJawClicked3);
    for (var i = 0; i < loading_order.length; i++) {
      if (
        loading_order[i].search('marker') > 0 ||
        loading_order[i].search('scanbody') > 0
      ) {
        if (
          loading_order[i].search('maxillary') > 0 ||
          loading_order[i].search('upperjaw') > 0
        ) {
          sumMESH[i].visible = !sumMESH[i].visible;
          if (!sumMESH[i].visible) {
            document.getElementsByClassName('slider3')[0].disabled = true;
            document.getElementsByClassName('slider3')[0].style.cursor = 'default';
            document.getElementsByClassName('upper-right2')[0].style.opacity = '0.45';
            setSliderValue3(0);
            setTransparent(arrObj[i], 0);
          } else {
            document.getElementsByClassName('slider3')[0].disabled = false;
            document.getElementsByClassName('slider3')[0].style.cursor = 'pointer';
            document.getElementsByClassName('upper-right2')[0].style.opacity = '1';
            setSliderValue3(100);
            setTransparent(arrObj[i], 100);
          }
        }
      }
    }
  };

  const LowerJaw1 = (sumMESH) => {
    setIsJawClicked4(!isJawClicked4);
    for (var i = 0; i < loading_order.length; i++) {
      if (
        loading_order[i].search('mandibular-preop') > 0 ||
        loading_order[i].search('lowerjaw-preop') > 0
      ) {
        sumMESH[i].visible = !sumMESH[i].visible;
        if (!sumMESH[i].visible) {
          document.getElementsByClassName('slider4')[0].disabled = true;
          document.getElementsByClassName('slider4')[0].style.cursor = 'default';
          document.getElementsByClassName('lower-right3')[0].style.opacity = '0.45';
          setSliderValue4(0);
          setTransparent(arrObj[i], 0);
        } else {
          document.getElementsByClassName('slider4')[0].disabled = false;
          document.getElementsByClassName('slider4')[0].style.cursor = 'pointer';
          document.getElementsByClassName('lower-right3')[0].style.opacity = '1';
          setSliderValue4(100);
          setTransparent(arrObj[i], 100);
        }
      }
    }
  };
  const LowerJaw2 = (sumMESH) => {
    setIsJawClicked5(!isJawClicked5);

    // show/hide margin line
    for (var index = 0; index < loading_order_margin.length; index++) {
      var fileName = loading_order_margin[index];
      var filenameRegex = new RegExp('(.?[^?])-margin', 'gm');
      var matches = filenameRegex.exec(fileName); //ex) result: 17-margin
      if (matches != null && matches[0]) {
        var margin_number = matches[0].split(/-/); //result: [17, margin]
      }
      if (
        (Number(margin_number[0]) >= 31 && Number(margin_number[0]) <= 38) ||
        (Number(margin_number[0]) >= 41 && Number(margin_number[0]) <= 48)
      ) {
        marginObj[index].visible = !marginObj[index].visible;
      }
    }

    for (var i = 0; i < loading_order.length; i++) {
      //mainscan
      if (
        loading_order[i].search('marker') < 0 &&
        loading_order[i].search('scanbody') < 0 &&
        loading_order[i].search('preop') < 0
      ) {
        if (
          loading_order[i].search('mandibular') > 0 ||
          loading_order[i].search('lowerjaw') > 0
        ) {
          sumMESH[i].visible = !sumMESH[i].visible;
          setFindingJawVisible(4, sumMESH[i].visible);
          if (!sumMESH[i].visible) {
            document.getElementsByClassName('slider5')[0].disabled = true;
            document.getElementsByClassName('slider5')[0].style.cursor = 'default';
            document.getElementsByClassName('lower-right1')[0].style.opacity = '0.45';
            setSliderValue5(0);
            setTransparent(arrObj[i], 0);
          } else {
            document.getElementsByClassName('slider5')[0].disabled = false;
            document.getElementsByClassName('slider5')[0].style.cursor = 'pointer';
            document.getElementsByClassName('lower-right1')[0].style.opacity = '1';
            setSliderValue5(100);
            setTransparent(arrObj[i], 100);
          }
        }
      }
    }
  };
  const LowerJaw3 = (sumMESH) => {
    setIsJawClicked6(!isJawClicked6);
    for (var i = 0; i < loading_order.length; i++) {
      if (
        loading_order[i].search('marker') > 0 ||
        loading_order[i].search('scanbody') > 0
      ) {
        if (
          loading_order[i].search('mandibular') > 0 ||
          loading_order[i].search('lowerjaw') > 0
        ) {
          sumMESH[i].visible = !sumMESH[i].visible;
          if (!sumMESH[i].visible) {
            document.getElementsByClassName('slider6')[0].disabled = true;
            document.getElementsByClassName('slider6')[0].style.cursor = 'default';
            document.getElementsByClassName('lower-right2')[0].style.opacity = '0.45';
            setSliderValue6(0);
            setTransparent(arrObj[i], 0);
          } else {
            document.getElementsByClassName('slider6')[0].disabled = false;
            document.getElementsByClassName('slider6')[0].style.cursor = 'pointer';
            document.getElementsByClassName('lower-right2')[0].style.opacity = '1';
            setSliderValue6(100);
            setTransparent(arrObj[i], 100);
          }
        }
      }
    }
  };

  const onChange = (e) => {
    const targetClassName = e.target.className;
    const value = e.target.value;
    for (var i = 0; i < loading_order.length; i++) {
      if (targetClassName === 'slider1') {
        if (
          loading_order[i].search('maxillary-preop') > 0 ||
          loading_order[i].search('upperjaw-preop') > 0
        ) {
          setSliderValue1(value);
          setTransparent(arrObj[i], value);
        }
      } else if (targetClassName === 'slider2') {
        if (
          loading_order[i].search('marker') < 0 &&
          loading_order[i].search('scanbody') < 0
        ) {
          if (
            loading_order[i].search('maxillary') > 0 ||
            loading_order[i].search('upperjaw') > 0
          ) {
            setSliderValue2(value);
            setTransparent(arrObj[i], value);
          }
        }
      } else if (targetClassName === 'slider3') {
        if (
          loading_order[i].search('maxillary-scanbody') > 0 ||
          loading_order[i].search('upperjaw-marker') > 0
        ) {
          setSliderValue3(value);
          setTransparent(arrObj[i], value);
        }
      } else if (targetClassName === 'slider4') {
        if (
          loading_order[i].search('mandibular-preop') > 0 ||
          loading_order[i].search('lowerjaw-preop') > 0
        ) {
          setSliderValue4(value);
          setTransparent(arrObj[i], value);
        }
      } else if (targetClassName === 'slider5') {
        if (
          loading_order[i].search('marker') < 0 &&
          loading_order[i].search('scanbody') < 0
        ) {
          if (
            loading_order[i].search('mandibular') > 0 ||
            loading_order[i].search('lowerjaw') > 0
          ) {
            setSliderValue5(value);
            setTransparent(arrObj[i], value);
          }
        }
      } else if (targetClassName === 'slider6') {
        if (
          loading_order[i].search('mandibular-scanbody') > 0 ||
          loading_order[i].search('mandibular-marker') > 0
        ) {
          setSliderValue6(value);
          setTransparent(arrObj[i], value);
        }
      }
    }
  };

  const setTransparent = (mesh, value) => {
    const opacity = Number(value) / 100;
    const visibilityChanged =
      (mesh.material.opacity > 0) !== (opacity > 0);
    mesh.material.transparent = true;
    mesh.material.opacity = opacity;
    if (mesh.material.uniforms?.uOpacity) {
      mesh.material.uniforms.uOpacity.value = opacity;
    }

    mesh.material.depthWrite = false;

    if (opacity === 1) {
      //opacity
      mesh.material.transparent = false;
      mesh.material.depthWrite = true;
    }

    const ownerMeshType = getOwnerMeshType(mesh.userData.fileName);
    if (ownerMeshType !== null && findingGroup) {
      findingGroup.children.forEach((marker) => {
        if (marker.userData.ownerMeshType !== ownerMeshType) return;
        marker.material.opacity = opacity;
        marker.visible = mesh.visible && opacity > 0;
      });
    }

    if (visibilityChanged && focusVisibleJawOnReset) {
      requestAnimationFrame(recenterVisibleJaws);
    }
    // mesh.onBeforeRender = function(renderer){renderer.clearDepth();};
  };

  const slideIn = () => {
    transControl.enabled = false;
    // transControl.slider_flag = true;
  };
  const slideOut = () => {
    transControl.enabled = true;
    // transControl.slider_flag = false;
  };

  const Solid = (sumMESH, temp_colors, geoLen, colors) => {
    setIsSolidClicked(!isSolidClicked);

    if (fileType === 'ply' || fileType === 'obj') {
      if (!isSolidClicked) {
        //Solid
        ambi_light.color.setHex(0xeda942);
        for (var i = 0; i < arrObj.length; i++) {
          for (var j = 0; j < geoLen[i]; j++) {
            colors[i][j] = 255 / 255.0;
            colors[i][j + 1] = 255 / 255.0;
            colors[i][j + 2] = 255 / 255.0;
          }
        }

        for (var i = 0; i < arrObj.length; i++) {
          sumMESH[i].geometry.attributes.color.needsUpdate = true;
        }
      } else {
        //VertexColors
        ambi_light.color.setHex(0xffffff);
        for (var i = 0; i < arrObj.length; i++) {
          for (var j = 0; j < geoLen[i]; j++) {
            colors[i][j] = temp_colors[i][j];
            colors[i][j + 1] = temp_colors[i][j + 1];
            colors[i][j + 2] = temp_colors[i][j + 2];
          }
        }

        for (var i = 0; i < arrObj.length; i++) {
          sumMESH[i].geometry.attributes.color.needsUpdate = true;
        }
      }
    }
  };

  const handleResetClick = () => {
    setIsResetClicked(true);
    resetAllMeshes();
    setTimeout(() => {
      setIsResetClicked(false);
    }, 50);
  };

  const handleSpecularLightClick = () => {
    const nextEnabled = !isSpecularLightEnabled;

    arrObj.forEach((mesh) => {
      const specularUniform = mesh.material?.uniforms?.uSpecularEnabled;
      if (specularUniform) {
        specularUniform.value = nextEnabled ? 1 : 0;
      }
    });

    setIsSpecularLightEnabled(nextEnabled);
  };

  return (
    <SliderContainer>
      <div className="slider">
        {/* Pre-Op */}
        <div className="upper1" style={getJawControlStyle('upper1')}>
          <div className="upper-left" onClick={() => UpperJaw1(arrObj)}>
            <SVG
              name="UpperPreop"
              color={isJawClicked1 ? themeContext.main_color : '#303945'}
              opacity={isJawClicked1 ? '1' : '0.66'}
            />
          </div>
          <div className="upper-right3">
            <input
              type="range"
              min="0"
              max="100"
              value={sliderValue1}
              onChange={onChange}
              className="slider1"
              onMouseOver={slideIn}
              onMouseOut={slideOut}
            />
          </div>
        </div>

        <div className="upper2" style={getJawControlStyle('upper2')}>
          <div className="upper-left" onClick={() => UpperJaw2(arrObj)}>
            <SVG
              name="Upper"
              color={isJawClicked2 ? themeContext.main_color : '#303945'}
              opacity={isJawClicked2 ? '1' : '0.66'}
            />
          </div>
          <div className="upper-right1">
            <input
              type="range"
              min="0"
              max="100"
              value={sliderValue2}
              onChange={onChange}
              className="slider2"
              onMouseOver={slideIn}
              onMouseOut={slideOut}
            />
          </div>
        </div>

        <div className="upper3" style={getJawControlStyle('upper3')}>
          <div className="upper-left" onClick={() => UpperJaw3(arrObj)}>
            <SVG
              name="UpperBody"
              color={isJawClicked3 ? themeContext.main_color : '#303945'}
              opacity={isJawClicked3 ? '1' : '0.66'}
            />
          </div>
          <div className="upper-right2">
            <input
              type="range"
              min="0"
              max="100"
              value={sliderValue3}
              onChange={onChange}
              className="slider3"
              onMouseOver={slideIn}
              onMouseOut={slideOut}
            />
          </div>
        </div>

        <div className="lower1" style={getJawControlStyle('lower1')}>
          <div className="lower-left" onClick={() => LowerJaw1(arrObj)}>
            <SVG
              name="LowerPreop"
              color={isJawClicked4 ? themeContext.main_color : '#303945'}
              opacity={isJawClicked4 ? '1' : '0.66'}
            />
          </div>
          <div className="lower-right3">
            <input
              type="range"
              min="0"
              max="100"
              value={sliderValue4}
              onChange={onChange}
              className="slider4"
              onMouseOver={slideIn}
              onMouseOut={slideOut}
            />
          </div>
        </div>

        <div className="lower2" style={getJawControlStyle('lower2')}>
          <div className="lower-left" onClick={() => LowerJaw2(arrObj)}>
            <SVG
              name="Lower"
              color={isJawClicked5 ? themeContext.main_color : '#303945'}
              opacity={isJawClicked5 ? '1' : '0.66'}
            />
          </div>
          <div className="lower-right1">
            <input
              type="range"
              min="0"
              max="100"
              value={sliderValue5}
              onChange={onChange}
              className="slider5"
              onMouseOver={slideIn}
              onMouseOut={slideOut}
            />
          </div>
        </div>

        <div className="lower3" style={getJawControlStyle('lower3')}>
          <div className="lower-left" onClick={() => LowerJaw3(arrObj)}>
            <SVG
              name="LowerBody"
              color={isJawClicked6 ? themeContext.main_color : '#303945'}
              opacity={isJawClicked6 ? '1' : '0.66'}
            />
          </div>
          <div className="lower-right2">
            <input
              type="range"
              min="0"
              max="100"
              value={sliderValue6}
              onChange={onChange}
              className="slider6"
              onMouseOver={slideIn}
              onMouseOut={slideOut}
            />
          </div>
        </div>

        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            position: 'fixed',
            top: '50%',
            right: '6px',
            transform: 'translateY(-50%)',
            gap: '15px',
            userSelect: 'none',
            zIndex: 10,
            pointerEvents: 'auto',
          }}
        >
          {/* Bouton Reset */}
          <div
            onClick={handleResetClick}
            style={{
              width: '56px',
              height: '56px',
              cursor: 'pointer',
            }}
          >
            <SVG
              name="reset"
              color={isResetClicked ? '#E5621f' : '#303945'}
              opacity={isResetClicked ? '1' : '0.66'}
            />
          </div>

          {/* Bouton Solid */}
          <button
            type="button"
            aria-pressed="true"
            className="btn-toggle"
            style={{
              display: isSolidVisible ? 'block' : 'none',
              position: 'static',
              margin: 0,
              flexShrink: 0,
            }}
            onClick={() => Solid(arrObj, temp_colors, geoLen, colors)}
          >
            <SVG
              name="Solid"
              color={isSolidClicked ? themeContext.main_color : '#303945'}
              opacity={isSolidClicked ? '1' : '0.66'}
            />
          </button>

          <button
            type="button"
            aria-label="Toggle mesh brilliance"
            aria-pressed={isSpecularLightEnabled}
            title="Brilliance"
            className="btn-toggle"
            style={{
              display: isSpecularToggleVisible ? 'block' : 'none',
              position: 'static',
              margin: 0,
              flexShrink: 0,
            }}
            onClick={handleSpecularLightClick}
          >
            <SVG
              name="LightActivated"
              color={isSpecularLightEnabled ? themeContext.main_color : '#303945'}
              opacity={isSpecularLightEnabled ? '1' : '0.66'}
            />
          </button>

          {/* Bouton Measure */}
          <div
            onClick={handleMeasureClick}
            style={{
              width: '56px',
              height: '56px',
              marginTop: isSolidVisible ? '85px' : '15px',
              display: 'none',
            }}
          >
            <SVG
              name="measure"
              color={isMeasureClicked ? themeContext.main_color : '#303945'}
              opacity={isMeasureClicked ? '1' : '0.66'}
            />
          </div>
        </div>
      </div>
    </SliderContainer>
  );
}

export default React.memo(SliderBox);
